export const isSessionValid = state => {return state.authentication.isAuthenticated;};
